import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import './styles.less';
import { Field, FieldArray } from 'redux-form';
import { FormCheckboxField } from '../../../../../../../../semantic-ui/components/form-checkbox-field';
import { DocumentsComponent } from '../../documents';

const CompanySettingsFormView = ({ change, formValues, documentTypes, stages, isStagesLoading }) => {
	useEffect(() => {
		if (formValues?.stages?.done === false) {
			change('documents', []);
		}
	}, [formValues?.stages?.done, change]);

	return (
		<Grid className="create-company-setting-form">
			<>
				<Grid.Row className="create-company-setting-form__row">
					<Grid.Column className="create-company-setting-form__text">Транспорт моих ТЭО</Grid.Column>
				</Grid.Row>
				<Grid.Row className="create-company-setting-form__row">
					<Grid.Column width={7} className="company-setting-view__checkbox">
						Считать весь транспорт аккредитованным по умолчанию
					</Grid.Column>
					<Grid.Column width={6} className="create-setting-form__field">
						<div className="create-company-setting-form__checkbox">
							<Field name="transports" component={FormCheckboxField} toggle type="checkbox" />
						</div>
					</Grid.Column>
				</Grid.Row>
				<Grid.Row className="create-company-setting-form__row">
					<Grid.Column className="create-company-setting-form__text">Мой автопарк</Grid.Column>
				</Grid.Row>
				<Grid.Row className="create-company-setting-form__row">
					<Grid.Column width={7} className="company-setting-view__checkbox">
						Считать мой автопарк аккредитованным по умолчанию
					</Grid.Column>
					<Grid.Column width={6} className="create-setting-form__field">
						<div className="create-company-setting-form__checkbox">
							<Field name="my_transports" component={FormCheckboxField} toggle type="checkbox" />
						</div>
					</Grid.Column>
				</Grid.Row>
				<Grid.Row className="create-company-setting-form__row">
					<Grid.Column className="create-company-setting-form__text__small">
						Жизненный цикл заявки
					</Grid.Column>
				</Grid.Row>
				{!isStagesLoading &&
					stages?.map(el => (
						<Grid.Row className="create-company-setting-form__row" key={el.key}>
							<Grid.Column width={7} className="company-setting-view__checkbox">
								{el.name}
							</Grid.Column>
							<Grid.Column width={6} className="create-setting-form__field">
								<div className="create-company-setting-form__checkbox">
									<Field
										name={`stages.${el.key}`}
										component={FormCheckboxField}
										toggle
										type="checkbox"
										disabled={!el.editable}
									/>
								</div>
							</Grid.Column>
						</Grid.Row>
					))}
				{formValues?.stages?.done && (
					<FieldArray
						name="documents"
						component={DocumentsComponent}
						props={{ documentTypes, change, formValues }}
					/>
				)}
			</>
		</Grid>
	);
};

CompanySettingsFormView.propTypes = {
	companySettingInfo: PropTypes.object.isRequired,
	change: PropTypes.func.isRequired,
	formValues: PropTypes.object.isRequired,
	stages: PropTypes.array,
	documentTypes: PropTypes.array,
	isStagesLoading: PropTypes.bool.isRequired,
};

export { CompanySettingsFormView };
